module.exports = function() {
  return new Worker(__webpack_public_path__ + "4d855b46011fcb180c4d.worker.js");
};